import request from '@/utils/request'

// 查询列表
export function listUrl(data) {
    return request({
      url: '/web_api/duty/software/list',
      method: 'post',
      data: data
    })
  }